import React from 'react';
import { observer } from 'mobx-react';
import { TextInput } from '../design-system/inputs';
import { isMobile } from 'react-device-detect';
import { MenuItem } from '@mui/material';
import { TextDefault } from '../design-system/texts';
import { resourcePath } from '../../utils/helpers';
import { palette } from '../design-system/colors';
import { useTranslation } from 'react-i18next';

export default observer(
    ({ groupId, selectOptions, onChange, value, answer, label }) => {
        const { t } = useTranslation('assessment');

        const isCorrect = (optionValue) => {
            return answer && answer.correctAnswer[optionValue];
        };

        const isUserCorrect = (optionValue) => {
            return (
                isCorrect(optionValue) &&
                answer.userAnswer[groupId][optionValue]
            );
        };

        const isIncorrect = (optionValue) => {
            return (
                answer &&
                answer.userAnswer &&
                answer.correctAnswer &&
                answer.correctAnswer.value !== optionValue &&
                answer.userAnswer.value === optionValue
            );
        };

        /** Which option should be displayed */
        const getDisplayValue = () => {
            return (
                (answer && answer.userAnswer && answer.userAnswer.value) ||
                (answer &&
                    answer.correctAnswer &&
                    answer.correctAnswer.value) ||
                ''
            );
        };

        const answerIcon = (optionValue) => {
            if (answer) {
                if (isCorrect(optionValue)) {
                    return isMobile ? (
                        '✅'
                    ) : (
                        <img
                            src={resourcePath(
                                '/static/img/assessment/icon-correct.svg'
                            )}
                        />
                    );
                } else if (isIncorrect(optionValue)) {
                    return isMobile ? (
                        '❌'
                    ) : (
                        <img
                            src={resourcePath(
                                '/static/img/assessment/icon-incorrect.svg'
                            )}
                        />
                    );
                }
            }
        };

        const answerColor = (optionValue) => {
            if (isCorrect(optionValue)) {
                return palette.evergreen.aspargus;
            } else if (isIncorrect(optionValue)) {
                return palette.vibrant.red;
            } else {
                return palette.graphite.heavyMetal;
            }
        };

        return (
            <TextInput
                onChange={(e) => !answer && onChange(e, groupId)}
                value={value}
                label={label}
                select
                //disabled={!!answer} Not disabling this so the user can see which answer is correct
                isMobile={isMobile}
                overwriteGlobalStyles
                defaultValue={getDisplayValue()}
            >
                {isMobile ? (
                    <option value="" disabled>
                      {t('Please select')}
                    </option>
                ) : (
                    <MenuItem value="">
                        <TextDefault lighter italic>
                          {t('Please select')}
                        </TextDefault>
                    </MenuItem>
                )}
                {selectOptions.map((o) =>
                    isMobile ? (
                        <option key={o.value} value={o.value}>
                            {answerIcon(o.value)} {t(o.text)}
                        </option>
                    ) : (
                        <MenuItem
                            style={{
                                whiteSpace: 'normal',
                            }}
                            key={o.value}
                            value={o.value}
                        >
                            {answerIcon(o.value)}
                            <TextDefault color={answerColor(o.value)}>
                                {t(o.text)}
                            </TextDefault>
                        </MenuItem>
                    )
                )}
            </TextInput>
        );
    }
);
